import script from "./Article35.vue?vue&type=script&setup=true&lang=js"
export * from "./Article35.vue?vue&type=script&setup=true&lang=js"

import "./Article35.vue?vue&type=style&index=0&id=ab0a08ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0a08ae"]])

export default __exports__